<template>
    <!-- Show tagged users -->
    <div class="d-inline-block">
        <router-link v-for="t in tagged" :to="`/staff/${t.id}`" :key="t.id" :title="t.fname">
            <img :src="t.avatar" class="rounded-circle" style="height: 24px; margin-right: -4px">
        </router-link>
    </div>
</template>

<script>
export default {
    name: "Tagged",
    props: ['request'],

    computed: {
        tagged() {
            if (typeof this.request === 'string') {
                try {
                    return JSON.parse(this.request).tagged;
                } catch (error) {
                    return  []
                }
            }
            return this.request.tagged;
        }
    }
}
</script>

<style scoped>

</style>